module.exports = __webpack_public_path__ + "img/10-2.949561f5.png";